import {
  Template as Model,
  ResourceStore,
  TemplateService as Service,
} from '@/internal';

const service = new Service();

const store = new ResourceStore({
  model: Model,
  actions: {
    duplicate: ({commit}, payload) => {
      return service.duplicate(payload.id, payload).then((response) => {
        if (response) {
          const idInArray = ResourceStore.processData(Model.key, commit, response.data);
          return idInArray[0];
        }
      });
    },
  },
});

export default store.toObject();
